module.exports = __webpack_public_path__ + "media/images/empresa/emp_editar-563c0ef6ccc51d1d9cb5f6bb8b5a9cd4.svg";